import React from "react"
import { compose, withProps, withStateHandlers } from "recompact"
import sortBy from "lodash/sortBy"
import moment from "moment"
import { EyesOnIcon } from "@infotech/uikit-icons"
import { Flex } from "src/components/Grid"
import LoaderBox from "src/components/forms/fragments/LoaderBox"
import get from "lodash/get"
import {
  makeTransparent,
  DEFAULT_COLOR,
} from "src/containers/Calendar/helpers/eventToItem"
import { errorStyle, warningStyle } from "src/helpers/invalidStyle"
import EventCard from "../EventCard"
import styles from "./styles.css"

const DAY = 24 * 60 * 60 * 1000

function stringify(value) {
  return typeof value === `string` ? value : `${value}px`
}

const getLineStyle = (validate, uuid) => {
  if (validate[uuid]) {
    return validate[uuid].error ? errorStyle : warningStyle
  }
  return null
}

let currentGroupElement = null
export default compose(
  withProps(props => {
    // order events by startTime and check 1 day dif
    const sortData = sortBy(props.events.data, `startDateTime`)
    const { position } = props
    if (sortData.length) {
      let timeLabel = sortData[0].startDateTime
      sortData.forEach((item, key) => {
        sortData[key].eventType = props.eventTypes.data.find(
          ({ id }) => id === item.eventTypeId,
        )
        if (key !== 0 && item.startDateTime > timeLabel + DAY) {
          timeLabel = item.startDateTime
          sortData[key].timeLabel = timeLabel
        }
      })
    }
    // toggle event line opacity when wait events
    position.style.opacity = props.events.data.length ? 1 : 0.3
    // here we need to use parentElement because ref on element line use calendar
    // and we cant use it
    const linePosition = props.position.parentElement.getBoundingClientRect()
    // check loader position
    const loaderPositionX = linePosition.x + linePosition.width / 2 - 30
    const loaderPositionY = linePosition.y + 10
    const windowSize = currentGroupElement
      ? currentGroupElement.getBoundingClientRect()
      : 0
    let windowXPosition = 0
    let windowYPosition = 0
    if (windowSize) {
      const xPosition =
        window.innerWidth - linePosition.x - linePosition.width - 312
      const yPosition =
        window.innerHeight - linePosition.y - windowSize.height - 16
      if (xPosition >= 0 && yPosition >= 0) {
        windowXPosition = linePosition.width + 12
      }
      if (xPosition >= 0 && yPosition < 0) {
        windowXPosition = linePosition.width + 12
        windowYPosition = yPosition
      }
      if (xPosition < 0 && yPosition >= 0) {
        windowXPosition = -312
      }
      if (xPosition < 0 && yPosition < 0) {
        windowXPosition = -312
        windowYPosition = yPosition
      }
      if (currentGroupElement) {
        currentGroupElement.addEventListener(`mousewheel`, e => {
          currentGroupElement.scrollTop += e.deltaY
        })
      }
    }
    return {
      loaderX: loaderPositionX,
      loaderY: loaderPositionY,
      XPosition: windowXPosition + linePosition.x,
      YPosition: windowYPosition + linePosition.y,
      eventsList: sortData,
    }
  }),
  withStateHandlers(
    {
      eventModalData: null,
    },
    {
      toggleEventModalData: () => eventData => ({
        eventModalData: eventData,
      }),
      preventScroll: () => e => {
        e.preventDefault()
        e.stopPropagation()
      },
    },
  ),
)(
  ({
    loaderX,
    loaderY,
    XPosition,
    YPosition,
    eventModalData,
    toggleEventModalData,
    eventsList,
    onSelect,
    handleEventRemove,
    planAllEventsValidate,
    data: { isPlan },
    canDeleteEvent,
    canChangeStatus,
    canEditEvent,
  }) => (
    <div>
      <div
        className={styles.cardOverlay}
        onClick={() => !!onSelect && onSelect(null)}
      />
      {eventsList.length > 0 ? (
        <div
          className={styles[`window-container`]}
          ref={groupElement => {
            currentGroupElement = groupElement
          }}
          style={{
            left: stringify(XPosition),
            top: stringify(YPosition),
          }}
        >
          {eventsList.length > 0 &&
            eventsList.map(
              (item, key) =>
                item.name && (
                  <div className={styles[`event-container`]}>
                    {(key === 0 || item.timeLabel) && (
                      <Flex>
                        <span className={styles[`date-label`]}>
                          {moment(item.startDateTime).format(`LL`)}
                        </span>
                      </Flex>
                    )}
                    <div
                      className={styles[`option-wrapper`]}
                      onClick={() => toggleEventModalData(item)}
                      style={
                        isPlan
                          ? getLineStyle(planAllEventsValidate, item.uuid)
                          : null
                      }
                    >
                      <div
                        className={styles.circle}
                        style={{
                          backgroundColor: `${
                            get(item, `eventType.color`) === `#fff`
                              ? DEFAULT_COLOR
                              : makeTransparent(
                                  get(item, `eventType.color`, `#fe070b`),
                                  0.4,
                                )
                          }`,
                        }}
                      />
                      <span className={styles[`option-time`]}>
                        {moment(item.startDateTime).format(`LT`)}
                      </span>
                      <span className={styles[`option-name`]}>
                        {get(item, `name`)}
                      </span>
                    </div>
                  </div>
                ),
            )}
        </div>
      ) : (
        <div>
          {/*  TODO This overlay disable clicks on calendar when we wait events
              mb change this after */}
          <div
            className={styles[`loader-wrapper`]}
            style={{
              left: stringify(loaderX),
              top: stringify(loaderY),
            }}
          >
            <LoaderBox color="#2880ff" />
          </div>
        </div>
      )}
      {eventModalData && (
        <EventCard
          data={eventModalData}
          handleEventRemove={handleEventRemove}
          onSelect={onSelect}
          handleEventModalData={() => toggleEventModalData(null)}
          groupPosition={currentGroupElement}
          stackEvent
          disableDelete={!canDeleteEvent(eventModalData.data)}
          disableStatus={!canChangeStatus(eventModalData.data)}
          CustomEditIcon={
            !canEditEvent(eventModalData.data) ? EyesOnIcon : null
          }
        />
      )}
    </div>
  ),
)
